import classNames from '@ui-components-3/ui/lib/utils/classNames'
import { Link } from 'react-router-dom'
import { DASHBOARD_SCHEDULE } from 'constants/routing'
import { ScheduledActions } from './actionsBlock'
import Card from '../common/Card'
import EventSection from '../common/EventSection'
import { Schedule } from 'components/UI/svgIcons'

type ScheduleCardProps = {
  date?: string | Date
  visitReason: string
  patientFullName: string
  age: number
  location?: string
  pendingVisitId?: string
  modality: 'phone' | 'video' | 'chat'
  className?: string
  shouldDisableVisitPage: boolean
  isSuccess: boolean
  showAslPill?: boolean
}

const ScheduleCard = ({
  patientFullName,
  age,
  visitReason,
  location,
  date,
  pendingVisitId,
  shouldDisableVisitPage = false,
  modality,
  className,
  isSuccess,
  showAslPill,
}: ScheduleCardProps) => {
  const finalDate = date instanceof Date ? date : new Date(date)

  return (
    <Card
      TitleIcon={Schedule}
      TitleButton={
        <Link
          to={DASHBOARD_SCHEDULE}
          className="btn-small uppercase btn-primary-borderless text-white hover:text-neutral-300 px-0"
        >
          View all
        </Link>
      }
      title="Scheduled Visits"
      className={classNames('border border-primary-600', className)}
      titleClassName="bg-primary-600 text-white [&_svg]:fill-current"
      actions={
        <ScheduledActions
          shouldDisableVisitPage={shouldDisableVisitPage}
          pendingVisitId={pendingVisitId}
          isSuccess={isSuccess}
        />
      }
    >
      <EventSection
        date={finalDate}
        visitReason={visitReason}
        fullName={patientFullName}
        age={age}
        location={location}
        modality={modality}
        className="[&_svg]:fill-neutral-400"
        showAslPill={showAslPill}
      />
      <hr className="my-4" />
    </Card>
  )
}
export default ScheduleCard
